import { render, staticRenderFns } from "./index.vue?vue&type=template&id=af094d88&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=af094d88&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=af094d88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af094d88",
  null
  
)

export default component.exports